import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import {
  deleteDocument,
  getDocumentDownloadUrl,
  listDocuments,
  updateDocumentTags,
  uploadDocument,
} from '../services/ApiClient';

export function useUploadDocument() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: uploadDocument,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['documents'] });
    },
  });
}

export function useListDocuments(params: {
  asset_id?: number;
  transaction_id?: number;
}) {
  return useQuery({
    queryKey: ['documents', params],
    queryFn: () => listDocuments(params).then((res) => res.data),
  });
}

export function useDocumentDownloadUrl(id: number) {
  return useQuery({
    queryKey: ['document-download-url', id],
    queryFn: () => getDocumentDownloadUrl(id).then((res) => res.data.url),
    enabled: !!id,
  });
}

export function useDeleteDocument() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: deleteDocument,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['documents'] });
    },
  });
}

export function useUpdateDocumentTags() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ id, tags }: { id: number; tags: string[] }) =>
      updateDocumentTags(id, tags),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['documents'] });
    },
  });
}
